import { useEffect, useRef } from "react";
import { Outlet, useParams } from "react-router-dom";
import { useStudentStore } from "../hooks/use-student-store";
import StudentHeader from "./student/student-header";
import { StudentSubmissionStatus } from "@live-writing/models";

const StudentLayout = () => {
  const { code, submissionId } = useParams();
  const { initialise, submission, incrementTime, syncTimeToServer } = useStudentStore();
  const timerRef = useRef<ReturnType<typeof setInterval> | null>(null);
  const syncRef = useRef<ReturnType<typeof setInterval> | null>(null);

  useEffect(() => {
    if (code) {
      initialise(code, submissionId ? Number(submissionId) : undefined);
    }
  }, [code, submissionId, initialise]);

  useEffect(() => {
    if (!submission) return;

    timerRef.current = setInterval(() => {
      incrementTime();
    }, 1000);

    return () => {
      if (timerRef.current) {
        clearInterval(timerRef.current);
      }
    };
  }, [submission, incrementTime]);

  useEffect(() => {
    if (!submission || submission.status === StudentSubmissionStatus.COMPLETED) return;

    syncRef.current = setInterval(() => {
      syncTimeToServer();
    }, 30000);

    return () => {
      if (syncRef.current) {
        clearInterval(syncRef.current);
      }
    };
  }, [submission, syncTimeToServer]);

  if (!code) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <p className="text-lg text-gray-600">No pre-lesson code provided</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <StudentHeader />
      <main className="container mx-auto">
        <Outlet />
      </main>
    </div>
  );
};

export default StudentLayout;
